<div class="app-container">
  <!-- Header Navigation -->
  <header class="main-header">
    <div class="brand-header" (click)="router.navigate(['/home'])" style="cursor: pointer;">
      <img src="/Docsila_logo.png" alt="DocSila" class="brand-logo-header">
    </div>

    <!-- Breadcrumb for configuration view -->
    <div class="breadcrumb" *ngIf="viewMode === 'configuration'">
      <button class="breadcrumb-btn" (click)="backToTable()">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <polyline points="15 18 9 12 15 6"></polyline>
        </svg>
        Back to Documents
      </button>
      <span class="breadcrumb-separator">/</span>
      <span class="breadcrumb-current">Configuration</span>
    </div>

    <!-- Navigation Buttons in Header -->
    <div class="header-nav-buttons">
      <!-- Role Badge -->
      @if (authService.isAdmin) {
        <span class="role-badge admin-badge" [title]="'Admin - ' + getUserEmail()">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M12 2L2 7l10 5 10-5-10-5z"></path>
            <path d="M2 17l10 5 10-5M2 12l10 5 10-5"></path>
          </svg>
          <span>{{ getUsernameFromEmail() }}</span>
        </span>
      } @else {
        <span class="role-badge user-badge" [title]="'User - ' + getUserEmail()">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
            <circle cx="12" cy="7" r="4"></circle>
          </svg>
          <span>{{ getUsernameFromEmail() }}</span>
        </span>
      }
      
      <button class="header-nav-btn" (click)="navigateToSequencing()" title="Sequencing">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="nav-icon">
          <line x1="10" y1="6" x2="21" y2="6"></line>
          <line x1="10" y1="12" x2="21" y2="12"></line>
          <line x1="10" y1="18" x2="21" y2="18"></line>
          <path d="M4 6h1v4"></path>
          <path d="M4 10h2"></path>
          <path d="M6 18H4c0-1 2-2 2-3s-1-1.5-2-1"></path>
        </svg>
      </button>
      <button class="header-nav-btn" (click)="navigateToDataExtraction()" title="Data Extraction">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="nav-icon">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
          <polyline points="14 2 14 8 20 8"></polyline>
          <line x1="16" y1="13" x2="8" y2="13"></line>
          <line x1="16" y1="17" x2="8" y2="17"></line>
          <polyline points="10 9 9 9 8 9"></polyline>
        </svg>
      </button>
      <button class="header-nav-btn active" title="Versioning">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="nav-icon">
          <line x1="6" y1="3" x2="6" y2="15"></line>
          <circle cx="18" cy="6" r="3"></circle>
          <circle cx="6" cy="18" r="3"></circle>
          <path d="M18 9a9 9 0 0 1-9 9"></path>
        </svg>
      </button>
      <button class="header-nav-btn" title="External Mapping">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="nav-icon">
          <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
          <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
          <line x1="12" y1="22.08" x2="12" y2="12"></line>
        </svg>
      </button>

      
      <!-- Login/Logout Button (Last) -->
      @if (isAuthenticated) {
        <button class="header-nav-btn" (click)="logout()" title="Logout">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="nav-icon">
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
            <polyline points="16 17 21 12 16 7"></polyline>
            <line x1="21" y1="12" x2="9" y2="12"></line>
          </svg>
        </button>
      } @else {
        <button class="header-nav-btn" (click)="router.navigate(['/login'])" title="Login">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="nav-icon">
            <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"></path>
            <polyline points="10 17 15 12 10 7"></polyline>
            <line x1="15" y1="12" x2="3" y2="12"></line>
          </svg>
        </button>
      }
    </div>
  </header>

  <!-- Table View (Landing Page) -->
  <main class="main-content" *ngIf="viewMode === 'table'">
    <!-- Toolbar -->
    <div class="toolbar">
      <div class="toolbar-spacer"></div>
      <div class="toolbar-actions">
        <button class="btn-new-item" (click)="openNewDocDialog()">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <line x1="12" y1="5" x2="12" y2="19"></line>
            <line x1="5" y1="12" x2="19" y2="12"></line>
          </svg>
          New Item
        </button>
      </div>
    </div>

    <!-- Documents Table -->
    <div class="table-wrapper">
      @if (versioningDocuments.length > 0) {
        <table class="documents-table">
          <colgroup>
            <col style="width: 22%">
            <col style="width: 18%">
            <col style="width: 15%">
            <col style="width: 12%">
            <col style="width: 12%">
            <col style="width: 13%">
            <col style="width: 8%">
          </colgroup>
          <thead>
            <tr>
              <th>Document Name</th>
              <th>Document Type</th>
              <th>Document Code</th>
              <th>Samples</th>
              <th>Rules</th>
              <th>Added Date</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            @for (doc of versioningDocuments; track doc.id) {
              <tr class="data-row" (dblclick)="onRowDoubleClick(doc)">
                <td>
                  <div class="title-cell">
                    <span class="doc-name">{{ doc.documentName }}</span>
                  </div>
                </td>
                <td>
                  <div class="type-cell">
                    <span class="doc-type">{{ doc.documentType }}</span>
                  </div>
                </td>
                <td>
                  <div class="code-cell">
                    <span class="doc-code">{{ doc.documentCode }}</span>
                  </div>
                </td>
                <td>
                  <div class="count-cell">
                    <span class="count-value">{{ doc.samples }}</span>
                  </div>
                </td>
                <td>
                  <div class="count-cell">
                    <span class="count-value">{{ doc.rules }}</span>
                  </div>
                </td>
                <td>
                  <div class="date-cell">
                    <span class="date-value">{{ doc.addedDate | date: 'MMM d, y' }}</span>
                  </div>
                </td>
                <td>
                  <div class="status-cell">
                    <span class="status-badge" [class.status-active]="doc.status === 'Active'" [class.status-draft]="doc.status === 'Draft'">
                      {{ doc.status }}
                    </span>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      } @else {
        <div class="empty-state">
          <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" class="empty-icon">
            <line x1="6" y1="3" x2="6" y2="15"></line>
            <circle cx="18" cy="6" r="3"></circle>
            <circle cx="6" cy="18" r="3"></circle>
            <path d="M18 9a9 9 0 0 1-9 9"></path>
          </svg>
          <p class="empty-title">No Versioning Documents</p>
          <p class="empty-subtitle">Click "New Item" to create your first versioning configuration</p>
        </div>
      }
    </div>
  </main>

  <!-- Configuration View (Three Column Layout) -->
  <main class="content-grid" *ngIf="viewMode === 'configuration'">
    
    <!-- Column 1: Samples Selection -->
    <section class="column sample-column">
      <div class="card">
        <div class="title-with-button">
          <h2 class="card-title">Document Type</h2>
          <button class="btn-add-document" title="Add Samples">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="12" y1="5" x2="12" y2="19"></line>
              <line x1="5" y1="12" x2="19" y2="12"></line>
            </svg>
            Add Samples
          </button>
        </div>

        <div class="sample-list" *ngIf="samples.length > 0">
          <div *ngFor="let sample of samples; let i = index" 
               class="sample-item"
               [class.active]="selectedSample?.id === sample.id"
               (click)="selectSample(sample, i)">
            <div class="sample-info">
              <svg class="sample-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                <polyline points="14 2 14 8 20 8"></polyline>
              </svg>
              <div class="sample-details">
                <span class="sample-name">{{ sample.name }}</span>
                <span class="sample-pages">Pages {{ sample.pageRange }}</span>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="samples.length === 0" class="empty-state">
          <p>No samples available</p>
          <p class="empty-state-hint">Click "Add Samples" to create samples</p>
        </div>
      </div>
    </section>

    <!-- Column 2: PDF Viewer -->
    <section class="column viewer-column">
      <div class="card viewer-card">
        <div class="viewer-header-inline">
          <h2 class="card-title">Document Preview</h2>
          <div class="viewer-controls-inline">
            <div class="page-controls">
              <button class="control-btn" (click)="previousPage()" [disabled]="!pdfSrc || currentPage === 1" title="Previous Page">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <polyline points="15 18 9 12 15 6"></polyline>
                </svg>
              </button>
              <span class="page-counter">{{ pdfSrc ? currentPage + '/' + totalPages : '0/0' }}</span>
              <button class="control-btn" (click)="nextPage()" [disabled]="!pdfSrc || currentPage === totalPages" title="Next Page">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <polyline points="9 18 15 12 9 6"></polyline>
                </svg>
              </button>
            </div>
            <div class="zoom-controls">
              <button class="control-btn" (click)="zoomOut()" [disabled]="!pdfSrc || zoom <= 0.5" title="Zoom Out">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <circle cx="11" cy="11" r="8"></circle>
                  <line x1="8" y1="11" x2="14" y2="11"></line>
                  <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                </svg>
              </button>
              <span class="zoom-level">{{ (zoom * 100) | number:'1.0-0' }}%</span>
              <button class="control-btn" (click)="zoomIn()" [disabled]="!pdfSrc || zoom >= 3.0" title="Zoom In">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <circle cx="11" cy="11" r="8"></circle>
                  <line x1="11" y1="8" x2="11" y2="14"></line>
                  <line x1="8" y1="11" x2="14" y2="11"></line>
                  <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                </svg>
              </button>
            </div>
          </div>
        </div>

        <div class="pdf-container">
          @if (!pdfSrc) {
            <div class="empty-state">
              <svg class="empty-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                <polyline points="14 2 14 8 20 8"></polyline>
              </svg>
              <p>No document loaded</p>
              <p class="empty-subtitle">Select a sample to preview</p>
            </div>
          }

          @if (pdfSrc) {
            <pdf-viewer 
              [src]="pdfSrc" 
              [render-text]="true"
              [original-size]="false"
              [show-all]="false"
              [page]="currentPage"
              [zoom]="zoom"
              (after-load-complete)="onPdfLoadComplete($event)"
              style="width: 100%; height: 100%;"
            ></pdf-viewer>
          }
        </div>
      </div>
    </section>

    <!-- Column 3: Versioning Logic -->
    <section class="column config-column">
      <div class="card">
        <h2 class="card-title-no-border">Versioning Logic</h2>

        <div class="versioning-form">
          
          <!-- Sorting Order Section -->
          <div class="form-section">
            <h3 class="section-title">Sorting Order</h3>
            
            @for (rule of sortingRules; track rule.id) {
              <div class="sorting-rule">
                <select class="form-select" [(ngModel)]="rule.field">
                  <option value="" disabled>Select field</option>
                  @for (field of availableSortFields; track field) {
                    <option [value]="field">{{ field }}</option>
                  }
                </select>
                
                <div class="order-buttons">
                  <button 
                    class="order-btn"
                    [class.active]="rule.order === 'asc'"
                    (click)="rule.order = 'asc'"
                    title="Ascending">
                    ASC
                  </button>
                  <button 
                    class="order-btn"
                    [class.active]="rule.order === 'desc'"
                    (click)="rule.order = 'desc'"
                    title="Descending">
                    DESC
                  </button>
                </div>

                @if (sortingRules.length > 1) {
                  <button 
                    class="btn-remove"
                    (click)="removeSortingRule(rule.id)"
                    title="Remove rule">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <line x1="18" y1="6" x2="6" y2="18"></line>
                      <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                  </button>
                }
              </div>
            }

            <button class="btn-add-rule" (click)="addSortingRule()">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <line x1="12" y1="5" x2="12" y2="19"></line>
                <line x1="5" y1="12" x2="19" y2="12"></line>
              </svg>
              Add Sorting Order
            </button>
          </div>

          <!-- Group By Section -->
          <div class="form-section">
            <h3 class="section-title">Group By</h3>
            
            <div class="form-group">
              <select class="form-select" [(ngModel)]="groupByField">
                <option value="" disabled>Select field</option>
                @for (option of groupByOptions; track option) {
                  <option [value]="option">{{ option }}</option>
                }
              </select>
            </div>

            <div class="form-group">
              <label class="form-label">Group Prefix</label>
              <input 
                type="text" 
                class="form-input" 
                [(ngModel)]="groupPrefix"
                placeholder="Enter group prefix">
            </div>
          </div>

          <!-- Nomenclature Section -->
          <div class="form-section">
            <h3 class="section-title">Nomenclature</h3>
            
            <div class="form-group">
              <select class="form-select" [(ngModel)]="nomenclature">
                @for (option of nomenclatureOptions; track option) {
                  <option [value]="option">{{ option }}</option>
                }
              </select>
            </div>
          </div>

          <!-- Save Button -->
          <button class="btn-save" (click)="saveConfiguration()">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"></path>
              <polyline points="17 21 17 13 7 13 7 21"></polyline>
              <polyline points="7 3 7 8 15 8"></polyline>
            </svg>
            Save Configuration
          </button>

        </div>
      </div>
    </section>

  </main>
</div>
